/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Stopped_Ago_QuestionInputs */

const en_us2_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long ago did you stop?`)
};

const pt_br2_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo você parou?`)
};

const es_419_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Hace cuánto lo dejaste?`)
};

const pt_pt2_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo paraste?`)
};

const fr_fr2_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand as-tu arrêté ?`)
};

const de_de2_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann hast du aufgehört?`)
};

const it_it2_onboarding_experience_stopped_ago_question = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo fa hai smesso?`)
};

/**
* | output |
* | --- |
* | "How long ago did you stop?" |
*
* @param {Onboarding_Experience_Stopped_Ago_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_stopped_ago_question = /** @type {((inputs?: Onboarding_Experience_Stopped_Ago_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Stopped_Ago_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_stopped_ago_question(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_stopped_ago_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_stopped_ago_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_stopped_ago_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_stopped_ago_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_stopped_ago_question(inputs)
	return en_us2_onboarding_experience_stopped_ago_question(inputs)
});
export { onboarding_experience_stopped_ago_question as "onboarding.experience_stopped_ago.question" }